import { Component, Input } from '@angular/core';
@Component({
  standalone: false,
  selector: 'edit-button',
  template: `
    <text-button icon="edit" [disabled]="disabled">
      {{ textOverride || 'Redigera' }}
    </text-button>
  `,
})
export class EditButton {
  @Input() disabled = false;
  @Input() textOverride: string = null;
}
